import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import DocumentPreview from "./DocumentPreview";
import React, { useState } from "react";
import KmPageTitle from "src/components/layout/KmPageTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const DocumentPreviewView = (props) => {
  const classes = useStyles();
  const [title, setTitle] = useState("Dokument");

  return (
    <Page className={classes.root} title={title}>
      <KmPageTitle>{title}</KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <DocumentPreview titleUpdate={setTitle} />
        </Box>
      </Container>
    </Page>
  );
};

export default DocumentPreviewView;
